import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权
import request from '@/utils/request';
import * as apiUrl from '@/apiUrl';
import {
  filterAsyncRouter
} from './store/modules/permission'

const whiteList = ['/login','/404'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()

  if (whiteList.indexOf(to.path) !== -1) {
    return next()
  } 
  if (getToken()) {
    if (to.path === '/login') {
      next();
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if(!store.state.user.userInfo){
        // next({ path: '/login' })
        request.post(apiUrl.GET_USER_BY_TOKEN,{
          token:getToken()
        },"检查登陆中...").then((res)=>{
          if(res.error==0 && res.data){
             store.commit("SET_LOGIN_INFO",{
              token:getToken(),
              user:res.data
             })
             request.post(apiUrl.GET_MENU_DATA,{}).then((res)=>{
                  const asyncRouter = filterAsyncRouter(res.data)
                  console.log("asyncRouter=====",asyncRouter)
                  store.state.user.roles = ['ADMIN'];
                  store.dispatch('GenerateRoutes', asyncRouter).then(() => { // 存储路由
                      var aaa=router.addRoutes(asyncRouter) // 动态添加可访问路由表
                      console.log("asyncRouter",asyncRouter,aaa);
                      next({
                        ...to,
                        replace: true
                      }) // hack方法 确保addRoutes已完成
                     // setTimeout(()=>{
                     // },1000)
                  })
             })
            //  store.dispatch('GenerateRoutes', { menus,username }).then(() => { // 生成可访问的路由表
            //   router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            //   next({ ...to, replace: true })
            // })

            
          }else{
            next({ path: '/login' })
          }
        })
      }else{
        next();
       
      }
    }
  } else {
      next({path:'/login'})
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js